import React from "react";
import ReactSelect from "react-select";

const Select = (props) => (
    <ReactSelect className="form-control p-0 select-reset" {...props} />
);

export default Select;
